// extracted by mini-css-extract-plugin
module.exports = {"ReadMore":"_2EAAuHqsb6vULvm12WcpFX","text":"eF-JuOH4h93a540c8uDDw","desc":"jhYmZ-jnQaRB1-Oxab2A8","hidden":"_3jlnnqjSSG4lFyO8jOkGut"};